<template>
	<div class="grid-comp">
		<div class="grid-title">{{orderName}}<slot name="icontip"></slot></div>
		<el-table
			ref='table'
			class="grid-content"
			row-class-name="fx-cursor"
			:data="tableData"
			row-key="number"
			show-summary
			v-loadmore="loadMore"
			header-cell-class-name='is-header-cell'
			:summary-method="sumhandle"
			@header-dragend='headerDragend'
			@row-dblclick="rowClickHandle"
			@sort-change="sortChangeHandle"
			border
			height="100%">
			<el-table-column
				:fixed="true"
				label-class-name = "column-index"
				label="序号"
				type="index"
				width="70"
				align="center"
				v-if="showIndex">
			</el-table-column>
			<template v-for="(item, index) in dropCol">
				<el-table-column
					v-if="item.showFlag && (item.prop === 'realpremoney' || item.prop === 'realpremoneyafter')"
					:label-class-name="`fx-table-column fx-drog-${item.prop}`"
					:key="`col_${index}`"
					:prop="dropCol[index].prop"
					:label="item.label"
					:fixed = "item.fixed"
					:width="item.width"
					:align = "item.align"
					:show-overflow-tooltip = "true"
					:header-align = "item.headerAlign"
					:formatter="item.formatter">
					<template slot="header">
						<div v-show="item.prop === 'realpremoney'">
							可用余额（前）
							<el-tooltip class="item" effect="dark" placement="top-start">
								<div slot="content">充值/扣减前的预付货款余额</div>
								<i class="el-icon-info"></i>
							</el-tooltip>
						</div>
						<div v-show="item.prop === 'realpremoneyafter'">
							可用余额（后）
							<el-tooltip class="item" effect="dark" placement="top-start">
								<div slot="content">充值/扣减后的预付货款余额</div>
								<i class="el-icon-info"></i>
							</el-tooltip>
						</div>
					</template>
					<template slot-scope="scope">
						<div v-show="item.prop === 'realpremoney'">{{scope.row.realpremoney}}</div>
						<div v-show="item.prop === 'realpremoneyafter'">{{scope.row.realpremoneyafter}}</div>
					</template>
				</el-table-column>
				<el-table-column
					v-if="item.showFlag && (item.prop !== 'realpremoney' && item.prop !== 'realpremoneyafter')"
					:label-class-name="`fx-table-column fx-drog-${item.prop}`"
					:key="`col_${index}`"
					:prop="dropCol[index].prop"
					:label="item.label"
					:fixed = "item.fixed"
					:width="item.width"
					:align = "item.align"
					:show-overflow-tooltip = "true"
					:header-align = "item.headerAlign"
					sortable='custom'
					:formatter="item.formatter">
				</el-table-column>
			</template>
		</el-table>
	</div>
</template>
<script>
import { mapState } from 'vuex'

export default {
	name: 'GridComp',
	props: {
		tableData: {
			type: Array,
			default: () => []
		},
		gridCol: {
			type: Array,
			default: () => []
		},
		gridData: {
			type: Array,
			default: () => []
		},
		sumCol: {
			type: Object,
			default: () => {}
		}
	},
	data () {
		return {
			dropCol: [],
			showIndex: true,
			menu: []
		}
	},
	mounted () {
		this.fxColumnDrop()
		this.getAuthority('09_0001_0000_00,09_0002_0000_00,09_0004_0000_00')
	},
	computed: {
		...mapState([
			'orderMenu',
			'orderName',
			'throughPath',
			'throughParams'
		])
	},
	watch: {
		gridCol: {
			handler (val) {
				let temp = []
				this.dropCol = JSON.parse(JSON.stringify(val))
				this.dropCol.forEach((e) => {
					if (e.showFlag) {
						temp.push(e)
					}
				})
				if (temp.length === 0) {
					this.showIndex = false
				} else {
					this.showIndex = true
				}
				this.$nextTick(() => {
					this.initDrogCell()
				})
			},
			immediate: true
		},
		tableData: {
			handler (val) {
				// console.log(val)
			},
			immediate: true
		},
		gridData () {
			this.$nextTick(() => {
				this.initDrogCell()
			})
		}
	},
	methods: {
		headerDragend () {
			this.$refs.table.doLayout()
		},
		getWidth () {
			let list = document.querySelectorAll('.is-header-cell')
			let arr = []
			list.forEach(item => {
				arr.push(item.offsetWidth)
			})
			let num = (arr.length) / 2
			let tureArr = arr.slice(1, num)
			return tureArr
		},
		loadMore () {
			this.$emit('loadmore')
		},
		getAuthority (pid) {
			let params = {
				pId: pid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					let menu = this.orderMenu
					for (let i = 0; i < a.length; i++) {
						for (let j = 0; j < menu.length; j++) {
							if (a[i] === menu[j].authority) {
								menu[j].show = true
							}
						}
					}
					this.menu = menu
				}
			})
		},
		initDrogCell () {
			const iframe = window.frameElement
			// const wrapperTr = document.querySelector('.el-table__header-wrapper tr')
			const wrapperTr = iframe ? iframe.contentDocument.querySelector('.el-table__header-wrapper tr') : document.querySelector('.el-table__header-wrapper tr')
			if (wrapperTr) {
				let children = wrapperTr.childNodes
				children.forEach(item => {
					item.draggable = true
					item.addEventListener('mouseover', function (e) {
						if (item.style.cursor === 'col-resize') {
							item.draggable = false
						} else {
							item.draggable = true
						}
					}, true)
				})
			}
		},
		sumhandle (param) {
			let { columns } = param
			let sums = []
			let sumColArr = Object.keys(this.sumCol)
			columns.forEach((column, index) => {
				if (index === 0) {
					sums[index] = '总计'
					return false
				}
				if (sumColArr.includes(column.property) && this.sumCol[column.property] === 'sum') {
					let values = this.gridData.map(item => {
						return Number(item[column.property])
					})
					let sumValue = values.reduce((pre, cur) => {
						return pre + cur
					}, 0)
					sums[index] = this.$fxUtils.toFixedSHW(sumValue, 2)
				}
			})
			this.$nextTick(() => {
				this.$refs.table.doLayout()
			})
			return sums
		},
		getSumCols () {
			let columns = this.gridCol.filter(item => {
				return item.showFlag === true
			})
			let sums = {}
			let sumColArr = Object.keys(this.sumCol)
			if (sumColArr.length === 0) {
				return sums
			}
			columns.forEach((column, index) => {
				if (sumColArr.includes(column.prop) && this.sumCol[column.prop] === 'sum') {
					let values = this.gridData.map(item => {
						return Number(item[column.prop])
					})
					let sumValue = values.reduce((pre, cur) => {
						return pre + cur
					}, 0)
					sums[column.prop] = this.$fxUtils.toFixedSHW(sumValue, 2)
				}
			})
			return sums
		},
		fxColumnDrop () {
			this.$nextTick(() => {
				// const wrapperTr = document.querySelector('.el-table__header-wrapper tr')
				const iframe = window.frameElement
				const wrapperTr = iframe ? iframe.contentDocument.querySelector('.el-table__header-wrapper tr') : document.querySelector('.el-table__header-wrapper tr')
				let dragDom = null
				if (wrapperTr) {
					wrapperTr.addEventListener('dragstart', (e) => {
						e.stopPropagation()
						dragDom = e.target
					}, true)
					wrapperTr.addEventListener('dragover', (e) => {
						e.stopPropagation()
						e.preventDefault()
					}, true)
					wrapperTr.addEventListener('drop', (e) => {
						e.stopPropagation()
						if (dragDom !== e.target) {
							e.target.classList.remove('drog-active')
							let newIndex = this.getDrogTrueIndex(e.target)
							let oldIndex = this.getDrogTrueIndex(dragDom)
							this.dropCol.splice(newIndex, 0, this.dropCol.splice(oldIndex, 1)[0])
							this.$emit('update:gridCol', this.dropCol)
							this.$emit('dropCol')
						}
					}, true)
					wrapperTr.addEventListener('dragenter', (e) => {
						e.stopPropagation()
						if (e.target.className.indexOf('fx-table-column') !== -1) {
							if (dragDom !== e.target) {
								e.target.classList.add('drog-active')
							}
						}
					}, true)
					wrapperTr.addEventListener('dragleave', (e) => {
						e.stopPropagation()
						if (e.target.className.indexOf('fx-table-column') !== -1) {
							if (dragDom !== e.target) {
								e.target.classList.remove('drog-active')
							}
						}
					}, true)
				} else {
					console.error('Could not find table header element.')
				}
			})
		},
		rowClickHandle (row, event, column) {
			if (this.throughPath !== '') {
				if (row.ordertype === '退单') {
					return false
				}
				if (this.orderName === '单据支付对账明细表' || this.orderName === '支付流水报表') {
					if (row.ordernumber === '' && row.refundnumber === '') {
						return false
					}
				}
				let list = this.menu
				let flag = 0
				var throughName = ''
				for (let i = 0; i < list.length; i++) {
					if (list[i].path === this.throughPath) {
						throughName = list[i].label
						if (list[i].show === true) {
							flag++
						}
					}
				}
				if (flag > 0) {
					let query = {}
					if (this.orderName === '活动类型汇总表') {
						this.throughParams.forEach(item => {
							let paramObj = {
								field: item.field,
								op: item.op,
								value: row[item.field] === '满减' ? '0' : '1',
								type: item.type
							}
							query[item.field] = paramObj
						})
					} else {
						this.throughParams.forEach(item => {
							let paramObj = {
								field: item.field,
								op: item.op,
								value: row[item.field],
								type: item.type
							}
							query[item.field] = paramObj
						})
					}
					if (typeof this.$attrs.getCustomThroughParams === 'function') {
						let customThroughParams = this.$attrs.getCustomThroughParams()
						if (Array.isArray(customThroughParams)) {
							customThroughParams.forEach(item => {
								query[item.name] = item
							})
						}
					}
					let app = window.sessionStorage.getItem('app')
					if (app === 'scm8') {
						let params = {
							app: 'jsd',
							action: 'goBlank',
							data: {
								path: 'reportform/' + this.throughPath,
								query: '',
								id: '11',
								title: '报表',
								reportThroughPath: encodeURI(JSON.stringify(query))
							}
						}
						window.parent.postMessage(params, '*')
					} else {
						// console.log(query)
						this.$fxGoBlank({
							path: this.throughPath,
							query: { throughParams: encodeURI(JSON.stringify(query)) }
						}, this.$router)
					}
				} else {
					this.$message.error({
						message: `您没有查看${throughName}报表的权限!`
					})
				}
			}
		},
		getDrogTrueIndex (target) {
			let prop = [].find.call(target.classList, (item) => {
				return /^fx-drog-/.test(item)
			})
			if (prop) {
				prop = prop.replace(/^fx-drog-/, '')
				let index = this.gridCol.findIndex(item => {
					return item.prop === prop
				})
				return index
			} else {
				return 0
			}
		},
		sortChangeHandle (column) {
			this.$emit('sort-change', column)
		},
		getCurrentCols () {
			return this.dropCol
		}
	}
}
</script>
<style lang="stylus" scoped>
@import '~$assets/stylus/varsty.styl'
.grid-comp {
	min-height :0;
	width: 100%;
	flex: 1;
	display: flex;
	flex-direction: column;
	.grid-title {
		height: 40px;
		line-height: 40px;
		border-bottom: 1px solid #eee;
		text-align: left;
		padding-left: 20px;
		position:relative
		font-size:16px
		font-weight:700
		display: flex;
		align-items: center
		&::before {
			content: ''
			position:absolute
			height:20px
			width:3px
			background:$fxDefaultColor
			top: 9px;
			left: 10px;
		}
	}
	.grid-content {
		flex: 1;
		min-height :0;
	}
}
</style>
<style lang="stylus">
.grid-content th, .grid-content td{
	padding:5px 0 !important
}
.grid-content th {
	&.drog-active {
		color:#fff
		background-color:#eee
	}
	* {
		pointer-events: none
	}
}
.fx-drog-memorypremoney,.fx-drog-realpremoney,.fx-drog-lockpremoney,.fx-drog-realpremoneyafter{
	* {
		pointer-events: all !important
	}
}
.grid-comp .el-table__footer td {
	text-align: right !important
}
.el-table--scrollable-x .el-table__body-wrapper {
	z-index: 2;
}
// .grid-comp {
// 	.grid-content {
// 		.last-colum {
// 			border-right: none !important
// 		}
// 		.el-table__body-wrapper::-webkit-scrollbar {
// 			width: 10px;
// 			background-color: #F5F5F5;
// 		}
// 		.el-table__body-wrapper::-webkit-scrollbar-thumb {
// 			border-radius: 10px;
// 			-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
// 			background-color: #ccc;
// 		}
// 		.el-table__body-wrapper::-webkit-scrollbar-track {
// 			-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
// 			background-color: #F5F5F5;
// 			border-radius: 10px;
// 		}
// 	}
// }
</style>
